import { render } from "./OurTestimonial.vue?vue&type=template&id=53144f48&scoped=true"
import script from "./OurTestimonial.vue?vue&type=script&lang=js"
export * from "./OurTestimonial.vue?vue&type=script&lang=js"

import "./OurTestimonial.vue?vue&type=style&index=0&id=53144f48&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-53144f48"]])

export default __exports__